import PropTypes from 'prop-types';
import styled from 'styled-components';
import { IFrame, Modal } from '@figure/frontlib-gui';

const PointservFrame = styled(IFrame)`
  height: 80vh;
`;

const PointservModal = ({ isOpen, url, handleClose, verificationType }) => (
  <Modal size="lg" isOpen={isOpen} onClose={handleClose}>
    <PointservFrame src={url} title={`${verificationType} VERIFICATION`} />
  </Modal>
);

PointservModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  verificationType: PropTypes.string.isRequired,
};

export default PointservModal;
